import { ICellRendererParams } from "ag-grid-community";
import { ViewResultsIconAction } from "../Bid/BtnCellRenderer/BtnCellRenderer.styled";
import { ButtonActionContainer } from "../Bid/BtnCellRenderer/BtnCellRenderer.styled";
import { Button } from "@sede-enterprise/shell-ds-react-framework";
import { useAppDispatch } from "../../store";
import { ShowResultsPanelAction } from "../../store/Results/ActionCreator";
import { BidStatus } from "../../services";

export interface IAuctionResultRenderer extends ICellRendererParams { }

export const AuctionResultsRenderer: React.FC<IAuctionResultRenderer> = (
    props
) => {
  const dispatch = useAppDispatch();
  return (
      <ButtonActionContainer>
        <Button
          className="shell-button-renderer"
          size="xsmall"
          disabled={props.data.bidStatus !== BidStatus.Closed}
          onClick={() => {
              dispatch(ShowResultsPanelAction(props.data));
          }}>
            <ViewResultsIconAction />
            View
          </Button>
      </ButtonActionContainer>)
  };